import React, { Component } from 'react';
import { VictoryBar, VictoryChart, VictoryTheme, VictoryAxis } from 'victory';
import { buildOptions, buildChartData } from './../../utils/survey';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { Card, Divider } from 'antd';
import ResultTotalAnswers from '../ResultTotalAnswers';
import ResultTitle from '../ResultTitle';
import moment from 'moment';

class ResultMonths extends Component{
	
	getChart = (chartData, months) => {
		chartData.forEach((el)=>{
			el.id = months.indexOf(el.x)+1;
			return el;
		});
		chartData.sort((a, b)=>{
			return a.id - b.id
		});
		return chartData;
	}
	
	render() {
		const { stepAnswers, questions, id, intl: { formatMessage } } = this.props;
		const answerValues = Object.values(stepAnswers);
		const answerOptions = buildOptions(answerValues);
		const chartData = buildChartData(answerOptions);
		const months = moment.months();
	
		return (
			<Card className='Result'>
				<div className='Answer'>
					<ResultTitle questions={questions} id={id}/>
					<ResultTotalAnswers stepAnswers={stepAnswers}/>
				</div>
				<Divider/>
				<div className='Answer' style={{ width: '100%', maxWidth: 500, margin: '0 auto' }}>
					<VictoryChart
						
						theme={VictoryTheme.material}
						domainPadding={30}
						width={600}
						height={600}
					>
						<VictoryBar
							data={this.getChart(chartData, months)}
							x={(chart) => chart.x.slice(0, 3)}
							y={(chart) => chart.y}
							style = {{
								data: {
									fill: 'DeepSkyBlue',
									padding: 15,
									strokeWidth: 0
								},
							}}
						/>
						<VictoryAxis
							label={formatMessage(messages.labelX)}
							style={{
								axisLabel: { fontSize: 16, padding: 35 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 16, padding: 5 }
							}}
						/>
						<VictoryAxis
							dependentAxis
							label={formatMessage(messages.labelY)}
							tickFormat={(t) => `${Math.round(t)}`}
							style={{
								axisLabel: { fontSize: 16, padding: 35 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 14, padding: 2 }
							}}
						/>
					</VictoryChart>
				</div>
			</Card>
		);
	}
}

export default injectIntl(ResultMonths);





// WEBPACK FOOTER //
// ./src/components/ResultMonths/ResultMonths.js